import { useFeatureFlagConfig } from "src/feature/useFeatureFlag";
import type { FeatureConfig } from "../../FeatureConfig";
import {
  type BackendFeatureMap,
  backendFeatureMapping,
} from "./backendFeatureMapping";

export function useBackendFeatureMapping(): Partial<FeatureConfig> {
  const features = useFeatureFlagConfig() ?? {};

  return mapBackendFeatures(features, backendFeatureMapping);
}

export function mapBackendFeatures(
  backendFeatures: Record<string, boolean>,
  backendFeatureMapping: Partial<BackendFeatureMap>,
): Partial<FeatureConfig> {
  let partialConfig: Partial<FeatureConfig> = {};

  for (const [backendFeature, partialFrontendConfig] of Object.entries(
    backendFeatureMapping,
  )) {
    if (backendFeatures?.[backendFeature]) {
      partialConfig = { ...partialConfig, ...partialFrontendConfig };
    }
  }

  return partialConfig;
}
